import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'

export const insightsPortalCaperDashboardAccessControl: DomainAccessControlConfig = {
  permissions: Permission.ViewCaperDashboard,
  featureEntitlementIds: [FeatureEntitlements.Caper],
}
